import { Box } from '@mui/joy';
import { useTheme } from '@mui/joy/styles';
import { CustomCellRendererProps } from 'ag-grid-react';

import { DEFAULT_DETAIL_ROW_HEIGHT } from 'core/constants';
import { SelectionCountProvider } from 'core/states';
import { PartList } from 'elements/components';
import { IElementTemplate } from 'elements/types';

interface IProps extends CustomCellRendererProps {
  data: IElementTemplate;
}

export const DetailElementTemplate = ({ data }: IProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.level1,
        height: DEFAULT_DETAIL_ROW_HEIGHT,
        padding: 1.5,
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.background.body,
          borderRadius: 6,
          height: '100%',
          padding: '12px',
          width: '100%',
        }}
      >
        <SelectionCountProvider>
          <PartList elementTemplate={data} />
        </SelectionCountProvider>
      </Box>
    </Box>
  );
};
